import { render } from "./EditReminder.vue?vue&type=template&id=1858b594&scoped=true"
import script from "./EditReminder.vue?vue&type=script&lang=js"
export * from "./EditReminder.vue?vue&type=script&lang=js"

import "./EditReminder.vue?vue&type=style&index=0&id=1858b594&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1858b594"]])

export default __exports__